import { useMemo, useCallback, useEffect } from "react";

function FromNumbersDropdown({
  fromNumber,
  setFromNumber,
  setToggleFromNumbers,
  toggleFromNumbers,
}: {
  fromNumber: string;
  setFromNumber: Function;
  setToggleFromNumbers: Function;
  toggleFromNumbers: boolean;
}) {
  const handleFromNumber = useCallback(
    (phoneNumber: string) => {
      setFromNumber(phoneNumber);
      setToggleFromNumbers(false);
    },
    [setFromNumber, setToggleFromNumbers]
  );
  return <></>;
}

export default FromNumbersDropdown;
